import { mergeWith, uniq } from 'lodash/fp';

import { DataGranularity } from '../types';

export const mergeGranularity = (
    granularity1: DataGranularity = {},
    granularity2: DataGranularity = {}
): DataGranularity =>
    mergeWith(
        (obj = [], src = []) => {
            if (Array.isArray(obj)) {
                return uniq(obj.concat(src));
            }
        },
        granularity1,
        granularity2
    );

export const mergeGranularities = (granularities: DataGranularity[]): DataGranularity => {
    const mergedGranularity = granularities[0];

    granularities.forEach((obj) => {
        Object.entries(obj).forEach(([key, value]) => {
            if (!mergedGranularity.hasOwnProperty(key)) {
                // If key is not present in result, initialize with the array
                // from the current object
                mergedGranularity[key] = [...(value || [])];
            } else {
                // If key is already present in result, merge arrays (remove duplicates)
                mergedGranularity[key] = [
                    ...new Set([...mergedGranularity[key], ...(value || [])]),
                ];
            }
        });
    });

    return mergedGranularity;
};
